<template>
  <div class="w-100 h-100">
    <div
      ref="tableContainer"
      class="sort-div w-100"
    >
      <b-button
        v-if="isFiltered"
        v-b-tooltip.hover.bottom="'Change' + getNotationReportViewer"
        variant="secondary"
        class="floating-btn"
        size="sm"
        :disable="isLoading"
        @click="changeValueBatch('Concentration', 'group', true, 2)"
      >
        <b-icon
          aria-label="ChangeConc"
          icon="sliders"
          font-scale="1"
        />
      </b-button>
      <b-button
        v-if="isFiltered && ShowState.value"
        v-b-tooltip.hover.bottom="'Change state'"
        variant="warning"
        class="floating-btn"
        size="sm"
        :disable="isLoading"
        @click="changeValueBatch('State', 'state', false, ShowMapping.value ? 6 : 4)"
      >
        <b-icon
          aria-label="ChangeState"
          icon="bar-chart-steps"
          font-scale="1"
        />
      </b-button>
      <b-button
        v-if="!isFiltered && typeof(getCurrentReportViewer.configuration[FilesConfigKey])!=='undefined' && typeof(getCurrentReportViewer.configuration[FilesConfigKey].dataSort)!=='undefined'"
        v-b-tooltip.hover.bottom="'Reset sort settings'"
        variant="info"
        class="floating-btn"
        size="sm"
        :disable="isLoading"
        @click="eraseSort"
      >
        <b-icon
          aria-label="Help"
          icon="arrow-clockwise"
          font-scale="1"
        />
      </b-button>
      <b-button
        v-if="showEnable"
        v-b-tooltip.hover.bottom="enableAction?'Enable selected':'Disable selected'"
        :variant="enableAction?'primary':'danger'"
        size="sm"
        class="floating-btn"
        :disable="isLoading"
        @click="toggleEnable"
      >
        <b-icon
          v-if="enableAction"
          aria-label="Help"
          icon="check-circle"
          font-scale="1"
        />
        <b-icon
          v-else
          aria-label="Help"
          icon="x-circle"
          font-scale="1"
        />
      </b-button>
    </div>
    
    <div 
      v-if="isTableLoading"
      class="d-flex loading-spinner"
    >
      <b-spinner
        variant="primary"
        label="Loading"
      />
    </div>
    <vue-table-dynamic
      id="processed-data"
      ref="tableProcFiles"
      class="table-processed"
      :params="paramsTableProc"
      @cell-change="onCellChange"
      @sort-change="onSortChange"
      @cell-click="onCellClick"
    />
    <div class="config-processed w-100 pt-3">
      <CheckBoxConfiguration
        :controller="ShowMapping"
        :switchprop="true"
        class="extra-switch"
      />
      <CheckBoxConfiguration
        :controller="ShowState"
        :switchprop="true"
        class="extra-switch"
      />
      <CheckBoxConfiguration
        v-if="getCurrentReportViewer.reportLinked && getCurrentReportViewer.reportLinked.length > 0"
        :controller="CopySource"
        :switchprop="true"
        class="extra-switch"
      />
    </div>
  </div>
</template>

<script>
// https://github.com/TheoXiong/vue-table-dynamic
import VueTableDynamic from 'vue-table-dynamic'
import {getDataFiles} from '@/functions/extractData.js'
import CheckBoxConfiguration from '@/components/properties/elements/CheckBoxConfiguration.vue'
import { NameFilesConfig, SpecialDeleteName } from '@/common/plotDefinitions.js'
import { ExtraConfigKey, FilesConfigKey, NameExtraConfig } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { getScanFilesList } from '@/common/sharedDefinitions/reportDefinitions'
import { mapGetters, mapActions } from 'vuex'
import {checkBoxGraphConfCtrller} from '@/assets/classes/configuration.js'
import ReportInfo from '@/functions/ReportInfo.js'

//Regex Area
const reMappingField=RegExp('\\(([0-9]+)\\,([0-9]+)\\)')

//Root of the Context help folder
const rootContextFolder='Files/ProccessedData/'

const notifyZone = 'Proccessed Data'

const indexSortDict={
  2:'group',
  1:'title'
}
const DISABLED_LABEL = 'Disabled'
const ENABLED_LABEL = 'Enabled'
const zoneNotify='ProcessedData'
const notDefinedLabel = 'ND'
const defaultState = 'default'

export default {
  name: 'ProcessedData',
  components: {
    VueTableDynamic,
    CheckBoxConfiguration
  },
  data () {
    return {
      elementsConfig:[],
      paramsTableProc: {
        data: [['Id','Curve','Group','Status']],
        header: 'row',
        border: true,
        stripe: true,
        enableSearch: true,
        highlightedColor: 'rgb(210, 210, 210)',
        highlight: { row: [] },
        sort: [1,2,3],
        pagination: true,
        pageSize: 10,
        columnWidth: [{column: 0, width: '12.5%'},{column: 2, width: '20%'},{column: 3, width: '20%'}],
        maxWidth:500,
        edit:{column: [1,2]},
      },
      dataFiles:[],
      FilesConfigKey,
      showEnable:false,
      isFiltered:false,
      enableAction:false,
      indexArray:[],
      isLoading:false,
      isTableLoading:false,
      ShowMapping: new checkBoxGraphConfCtrller(
        NameExtraConfig.ShowMapping,'Show Mapping',false,rootContextFolder+'ShowMapping',true
      ),
      ShowState: new checkBoxGraphConfCtrller(
        NameExtraConfig.ShowState,'Show State',false,rootContextFolder+'ShowState',true
      ),
      CopySource: new checkBoxGraphConfCtrller(
        NameExtraConfig.CopySource,'Copy source configuration',true,rootContextFolder+'CopySource',true
      ),
    }
  },
  computed: mapGetters([
    'getCurrentReportViewer',
    'getNotationReportViewer'
  ]),
  async mounted () {
    this.elementsConfig = [
      this.ShowMapping,
      this.ShowState,
      this.CopySource,
    ]
    //Set the width with the size of the div container
    const newWidth = this.$refs.tableContainer.clientWidth;
    this.$set(this.paramsTableProc,'maxWidth',newWidth)
    await this.$nextTick()
    await this.$nextTick()
    await this.$nextTick()
    await this.$nextTick()
    await this.loadTable()
    this.$watch(
      '$refs.tableProcFiles.searchValue',
      (new_value) => {
        this.filterChanged(new_value)
      }
    );
    this.$watch(
      'ShowMapping.value',
      (new_value) => {
        this.showMappingChanged(new_value)
      }
    );
    this.$watch(
      'ShowState.value',
      (new_value) => {
        this.showStateChanged(new_value)
      }
    );
    this.$watch(
      'CopySource.value',
      (new_value) => {
        this.copySourceChanged(new_value)
      }
    );
    this.elementsConfig.forEach(conf=>conf.setParent(this))
  },
  methods:{
    ...mapActions([
      'addMessageTerminalSection',
      'setConfigReportModifiedReportViewer',
      'setScanFilesListReportViewer',
      'setMappingSetReportViewer',
      'setReportStatesListReportViewer'
    ]),
    prepareLinkedReportChanges(fileName, indexExtractedData){
      this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.LinkedReportChanges] = this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.LinkedReportChanges] || {}
      this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.LinkedReportChanges][fileName] = this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.LinkedReportChanges][fileName] || {}
      this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.LinkedReportChanges][fileName][indexExtractedData] = this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.LinkedReportChanges][fileName][indexExtractedData] || {}
    },
    parseFloatVal(value){
      const floatValue = parseFloat(value)
      if(!isNaN(floatValue) && String(value) !== String(floatValue)){
        const warnTitle='Value modified when parsing'
        const warnText=`The value was modified during parsing. Input: ${String(value)}. Value stored: ${floatValue}`
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.WARNING, warnTitle, warnText, zoneNotify)
      }
      return floatValue
    },
    parseIntVal(value){
      const intValue = parseInt(value)
      if(!isNaN(intValue) && String(value) !== String(intValue)){
        const warnTitle='Value modified when parsing'
        const warnText=`The value was modified during parsing. Input: ${String(value)}. Value stored: ${intValue}`
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.WARNING, warnTitle, warnText, zoneNotify)
      }
      return intValue
    },
    async onCellChange (rowIndex, columnIndex, rawData) {
      this.setConfigReportModifiedReportViewer()
      const rowData = this.paramsTableProc.data[rowIndex]
      const splitData = rowData[0].split('.') //Get the Id
      const changingFile = this.dataFiles[parseInt(splitData[0])]
      const indexExtractedData = parseInt(splitData[1])
      const changingCurve = changingFile.extractedData[indexExtractedData]
      const pagination = Math.floor(rowIndex/10)+1
      const searchVal = this.$refs.tableProcFiles.searchValue
      const modifLinkedFile = changingFile.linkedFile && !this.CopySource.value
      let data = typeof(rawData) === 'number' ? rawData : String(rawData).replace(/<\/?[^>]+(>|$)/g, '');

      if(changingFile.linkedFile && this.CopySource.value){
        const warnTitle='Modifying linked dataline'
        const warnText='Changes on linked dataline are not saved. Please disable the "Copy Source" switch'
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.WARNING, warnTitle, warnText, zoneNotify)
        this.$nextTick(() => this.loadTable(pagination, searchVal))
        return
      }

      if(data === SpecialDeleteName){
        const errTitle='Invalid value'
        const errText= `The key '${SpecialDeleteName}' is a reserved for special properties, please do not use it as a value`
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
        this.$nextTick(() => this.loadTable(pagination, searchVal))
        return
      }
      if(modifLinkedFile && typeof(changingCurve.fileName) === 'undefined'){
        const warnTitle='Incorrect file extraction'
        const warnText='The file was not extracted correctly in the source report. Please import the file again in the source report.'
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.WARNING, warnTitle, warnText, zoneNotify)
        this.$nextTick(() => this.loadTable(pagination, searchVal))
        return
      }

      if(columnIndex===1){
        if(data===''){
          const errTitle='Invalid title'
          const errText='The title cannot be empty'
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
          this.$nextTick(() => this.loadTable(pagination, searchVal))
          return
        }
        changingCurve.title = data
        this.setConfigReportModifiedReportViewer()
        if(modifLinkedFile){
          this.prepareLinkedReportChanges(changingCurve.fileName, indexExtractedData);
          this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.LinkedReportChanges][changingCurve.fileName][indexExtractedData].title = data
        }
      } else if(columnIndex===2){
        if(data==='')
          data = notDefinedLabel;
        if(data===notDefinedLabel){
          if(typeof(changingCurve.group)!=='undefined'){
            delete changingCurve.group
          }
          if(modifLinkedFile){
            this.prepareLinkedReportChanges(changingCurve.fileName, indexExtractedData);
            this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.LinkedReportChanges][changingCurve.fileName][indexExtractedData].group = SpecialDeleteName
          }
          this.$nextTick(() => this.loadTable(pagination, searchVal))
          return
        }
        if(typeof(data)==='string' && !isNaN(parseFloat(data))){
          data = this.parseFloatVal(data)
        }
        if(typeof(data)==='number'){//Check if the input data is number, or rever the change
          changingCurve.group = data
          if(modifLinkedFile){
            this.prepareLinkedReportChanges(changingCurve.fileName, indexExtractedData);
            this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.LinkedReportChanges][changingCurve.fileName][indexExtractedData].group = data
          }
          this.setConfigReportModifiedReportViewer()
        }else{
          const errTitle='Wrong value'
          const errText=`The value ${data} is not a number. Please give a valid number`
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
          this.$nextTick(() => this.loadTable(pagination, searchVal))
        }
      }else if(columnIndex===4){
        if(this.ShowMapping.value){
          this.updateMappingValue(data, rowData, changingCurve, rowIndex, modifLinkedFile, indexExtractedData)
        }else{
          await this.updateStateValue(data, changingCurve, rowIndex, 4, modifLinkedFile, indexExtractedData)
        }
      }else if(columnIndex===5){
        const oldValue = rowData[5]
        // Needs to verify the list and verify that the old value still have some values, 
        //  otherwise it needs to remove
        if(oldValue !== '' || oldValue !==notDefinedLabel){
          // Try to find an element with the same Scan value
          const sameMapping = this.paramsTableProc.data.findIndex(d=>d[5] === oldValue && d[3] === ENABLED_LABEL && d[0]!==rowData[0])
          if(sameMapping === -1){
            // It means it didn't find so it removes the value
            delete this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.ScansFiles][oldValue]
            const scanFilesList = await getScanFilesList(this.getCurrentReportViewer)
            this.setScanFilesListReportViewer(scanFilesList)
          }
        }
        if(data === '' || data ===notDefinedLabel){
          delete changingCurve.scan
          if(modifLinkedFile){
            this.prepareLinkedReportChanges(changingCurve.fileName, indexExtractedData);
            this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.LinkedReportChanges][changingCurve.fileName][indexExtractedData].scan = SpecialDeleteName
          }
          this.setConfigReportModifiedReportViewer()
          this.$nextTick(() => this.loadTable(pagination, searchVal))
          return
        }
        const integerValue = this.parseIntVal(data)
        if(isNaN(integerValue) || integerValue < 0){
          const errTitle='Invalid Mapping'
          const errText= 'The scan must be a positive integer value'
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
          this.$nextTick(() => this.loadTable(pagination, searchVal))
          return
        }
        if(typeof(this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.ScansFiles])==='undefined'){
          this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.ScansFiles]={}
        }
        // Update the dictionary with the available scans
        if(typeof(this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.ScansFiles][integerValue])==='undefined'){
          this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.ScansFiles][integerValue] = true
          const scanFilesList = await getScanFilesList(this.getCurrentReportViewer)
          this.setScanFilesListReportViewer(scanFilesList)
        }
        changingCurve.scan = integerValue
        if(modifLinkedFile){
          this.prepareLinkedReportChanges(changingCurve.fileName, indexExtractedData);
          this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.LinkedReportChanges][changingCurve.fileName][indexExtractedData].scan = integerValue
        }
        this.paramsTableProc.data[rowIndex][5] = integerValue
        this.setConfigReportModifiedReportViewer()
      }else if(columnIndex===6){
        await this.updateStateValue(data, changingCurve, rowIndex, 6, modifLinkedFile, indexExtractedData)
      }
      this.$nextTick(() => this.loadTable(pagination, searchVal))
    },
    updateMappingValue(data, rowData, changingCurve, rowIndex, modifLinkedFile, indexExtractedData){
      const matchMappingRgx = reMappingField.exec(data)
        if(matchMappingRgx === null){
          const errTitle='Invalid Mapping'
          const errText='The mapping value must be in the format \'X.Y\', with all of the values being integers.'
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
          this.$nextTick(() => this.loadTable())
          return
        }
        const scanValue = rowData[5]
        const newValueFormatted = `(${matchMappingRgx[1]},${matchMappingRgx[2]})`
        const sameMapping = this.paramsTableProc.data.findIndex(d=>d[4] === newValueFormatted && d[3] === ENABLED_LABEL && d[5] === scanValue)
        if(sameMapping !== -1){
          const errTitle='Repeated Mapping'
          const errText=`The mapping ${newValueFormatted} in Scan ${scanValue} exists in the element number ${sameMapping}`
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
          this.$nextTick(() => this.loadTable())
          return
        }
        changingCurve.mapping = [matchMappingRgx[1],matchMappingRgx[2]]
        if(modifLinkedFile){
          this.prepareLinkedReportChanges(changingCurve.fileName, indexExtractedData);
          this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.LinkedReportChanges][changingCurve.fileName][indexExtractedData].mapping = [matchMappingRgx[1],matchMappingRgx[2]]
        }
        this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.MappingPresent]=true
        this.setMappingSetReportViewer(true)
        this.paramsTableProc.data[rowIndex][4] = newValueFormatted
        this.setConfigReportModifiedReportViewer()
    },
    async updateStateValue(data, changingCurve, rowIndex, columnIndex, modifLinkedFile, indexExtractedData){
      try{
        if(data === ''){
          data = defaultState;
          const warnTitle='Invalid state'
          const warnText='The state cannot have an empty value'
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.WARNING,warnTitle,warnText,zoneNotify)
        }
        if(data === defaultState){
          delete changingCurve.state
          if(modifLinkedFile){
            this.prepareLinkedReportChanges(changingCurve.fileName, indexExtractedData);
            this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.LinkedReportChanges][changingCurve.fileName][indexExtractedData].state = SpecialDeleteName
          }
          this.setConfigReportModifiedReportViewer()
          this.$nextTick(() => this.loadTable())
          return
        }
        changingCurve.state = data
        if(modifLinkedFile){
          this.prepareLinkedReportChanges(changingCurve.fileName, indexExtractedData);
          this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.LinkedReportChanges][changingCurve.fileName][indexExtractedData].state = data
        }
        this.paramsTableProc.data[rowIndex][columnIndex] = data
        this.setConfigReportModifiedReportViewer()
      }catch(e){
        const errTitle='Error updating state'
        const errText='Please update the previous value again'
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
      } finally{
        const statesReport = await ReportInfo.getStatesList(this.getCurrentReportViewer)
        this.setReportStatesListReportViewer(statesReport)
      }
    },
    async loadTable(pagination = null,searchVal=''){
      this.isTableLoading = true
      try{
        this.dataFiles = await getDataFiles(this.getCurrentReportViewer)
        let unSortedData=[]
        this.indexArray = []
        for(let j=0;j<this.dataFiles.length;j++){
          const extracted = this.dataFiles[j].extractedData
          this.indexArray.push([])
          for(let n=0;n<extracted.length;n++){
            // We must place it on the controller as String, otherwise it won't detect changes when changing 0->''
            const conc = typeof(extracted[n].group)!=='undefined'?extracted[n].group.toString():notDefinedLabel
            const status = typeof(extracted[n].enabled)!=='undefined' && !extracted[n].enabled?DISABLED_LABEL.slice():ENABLED_LABEL.slice()
            this.indexArray[j].push(unSortedData.length+1)
            const newRow = [`${j}.${n}`,extracted[n].title,conc,status]
            if(this.ShowMapping.value){
              newRow.push(typeof(extracted[n].mapping)!=='undefined'?`(${extracted[n].mapping[0]},${extracted[n].mapping[1]})`:'')
              newRow.push(typeof(extracted[n].scan)!=='undefined'?extracted[n].scan:'ND')
            }
            if(this.ShowState.value){
              newRow.push(typeof(extracted[n].state)!=='undefined'?extracted[n].state:defaultState)
            }
            unSortedData.push(newRow)
          }
        }
        //Sorting the unsorted data
        if(typeof(this.getCurrentReportViewer.configuration[FilesConfigKey])!=='undefined'&&typeof(this.getCurrentReportViewer.configuration[FilesConfigKey][NameFilesConfig.dataSort])!=='undefined'){
          const dataSort=this.getCurrentReportViewer.configuration[FilesConfigKey][NameFilesConfig.dataSort]
          const arrayIndex=Object.keys(indexSortDict).find(key => indexSortDict[key] === dataSort.property)
          if(typeof(arrayIndex)==='undefined'){ //If cannot find the element in the sort dictionary just remove sorting configuration and warn the user
            this.setConfigReportModifiedReportViewer()
            this.eraseSort()
            const messageWarning = 'Error retrieving the sorting configuration, please configure again and save the getCurrentReportViewer.'
            this.$notify({
              group: 'AppGeneralUser',
              title: 'Extracting data',
              type: 'warn',
              text: messageWarning
            })
            this.addMessageTerminalSection({
              type:'WARN',
              text:`ExtractData.Get Data File. ${messageWarning}`
            })
            return
          }
          if(dataSort.value==='ascending'){
            unSortedData=unSortedData.sort((a,b)=>{return a[arrayIndex]>b[arrayIndex]?1:-1})
          }else{
            unSortedData=unSortedData.sort((a,b)=>{return a[arrayIndex]<b[arrayIndex]?1:-1})
          }
        }
        const newHighLight = []
        //Paint the disabled elements
        for(let j=0;j<unSortedData.length;j++){
          if(unSortedData[j][3]===DISABLED_LABEL){
            newHighLight.push(j+1)
          }
        }
        const headerTable = ['Id','Curve','Group','Status']
        if(this.ShowMapping.value){
          headerTable.push('Map', 'Scan')
        }
        if(this.ShowState.value){
          headerTable.push('State')
        }
        const newData = ([headerTable]).concat(unSortedData)
        this.$set(this.paramsTableProc,'data',newData)
        this.$set(this.paramsTableProc,'highlight',{row:newHighLight})
        //Selct the columns that it is possible to edit
        const editColumns = [1,2]
        let stateColumn = 4
        if(this.ShowMapping.value){
          editColumns.push(4,5)
          stateColumn = 6
        }
        if(this.ShowState.value){
          editColumns.push(stateColumn)
        }
        this.$set(this.paramsTableProc,'edit',{column: editColumns})
        //Select the width of the columns
        const widthColumns = [{column: 0, width: '12.5%'},{column: 2, width: '20%'},{column: 3, width: '20%'}]
        if(this.ShowMapping.value){
          widthColumns.push({column: 4, width: '12%'}, {column: 5, width: '12%'})
        }
        if(this.ShowMapping.value){
          widthColumns.push({column: stateColumn, width: '11%'})
        }
        this.$set(this.paramsTableProc,'columnWidth',widthColumns)
        if(pagination !==null && pagination>1){
          this.$nextTick(() => this.$nextTick(() =>this.$refs.tableProcFiles.toPage(pagination)))
        }
        if(searchVal!==''){
          this.$nextTick(() => this.$nextTick(() => this.$refs.tableProcFiles.searchValue = searchVal))
        }
      }catch(e){
        const errTitle='Error updating table'
        const errText='Cannot load the processed data table'
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
      } finally{
        this.isTableLoading = false
      }
    },
    onSortChange(index,value){
      if(index === 3){
        return
      }
      this.setConfigReportModifiedReportViewer()
      const property=indexSortDict[index]
      if(typeof(this.getCurrentReportViewer.configuration[FilesConfigKey])==='undefined'){
        this.$set(this.getCurrentReportViewer.configuration,FilesConfigKey,{})  
      }
      this.$set(this.getCurrentReportViewer.configuration[FilesConfigKey],NameFilesConfig.dataSort,{property,value})
      this.setConfigReportModifiedReportViewer()
    },
    eraseSort(){
      this.setConfigReportModifiedReportViewer()
      this.showEnable = false
      this.isFiltered = false
      this.$delete(this.getCurrentReportViewer.configuration[FilesConfigKey],[NameFilesConfig.dataSort])
      this.setConfigReportModifiedReportViewer()
      this.loadTable()
    },
    async filterChanged(value){
      const [, ...resultsFilt] = this.$refs.tableProcFiles.tableData.activatedRows
      this.enableAction = resultsFilt.some(row=>row.cells[3].data===DISABLED_LABEL)
      this.showEnable = value!==''
      this.isFiltered = value!==''
    },
    showMappingChanged(){
      this.loadTable()
    },
    showStateChanged(){
      this.loadTable()
    },
    copySourceChanged(newVal){
      if(newVal){
        this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.LinkedReportChanges] = {}
      }
      this.loadTable()
    },
    async toggleEnable(){
      this.isLoading = true
      const oldPageSize = this.$refs.tableProcFiles.pageSize
      this.$refs.tableProcFiles.pageSize = 10000
      await this.$nextTick()
      await this.$nextTick()
      const [, ...resultsFilt] = this.$refs.tableProcFiles.tableData.activatedRows
      for(let j=0;j<resultsFilt.length;j++){
        const indexCol = resultsFilt[j].cells[0].data
        this.changeEnableRow(indexCol,this.enableAction)
      }
      await this.loadTable()
      this.$refs.tableProcFiles.pageSize = oldPageSize
      this.isLoading = false
      this.setConfigReportModifiedReportViewer()
    },
    
    async changeValueBatch(fieldNamePrompt, fieldNameObjt, isNumber, columnIndex){
      this.isLoading = true
      const oldPageSize = this.$refs.tableProcFiles.pageSize
      this.$refs.tableProcFiles.pageSize = 10000
      await this.$nextTick()
      await this.$nextTick()
      const [, ...resultsFilt] = this.$refs.tableProcFiles.tableData.activatedRows
      this.$refs.tableProcFiles.pageSize = oldPageSize
      if(resultsFilt.length===0){
        this.isLoading = false
        const errText='No rows selected'
        const errTitle='Error, no rows selected to change'
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,notifyZone)
        return
      }
      let newValue = null
      while(newValue ===null){
        try{
          if(isNumber){
            newValue = this.parseFloatVal(await this.$prompt(`Enter the new ${fieldNamePrompt} value`,resultsFilt[0].cells[columnIndex].data,'New numeric value','question'))
            if(isNaN(newValue)){
              newValue = null
              const errText='Enter a valid number'
              const errTitle='Invalid ' + this.getNotationReportViewer
              this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,notifyZone)
            }
          }else{
            newValue = await this.$prompt(`Enter the new ${fieldNamePrompt} value`,resultsFilt[0].cells[columnIndex].data,'New value','question')
            if(!newValue){
              newValue = null
              const errText='Enter a valid value'
              const errTitle='Invalid ' + this.getNotationReportViewer
              this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,notifyZone)
            }
          }
          
        } catch{
          return
        }
      }
      for(let j=0;j<resultsFilt.length;j++){
        const indexCol = resultsFilt[j].cells[0].data
        this.setConfigReportModifiedReportViewer()
        const splitData = indexCol.split('.') //Get the Id
        const fileIndex = parseInt(splitData[0])
        const indexExtractedData = parseInt(splitData[1])
        const changingFile = this.dataFiles[fileIndex]
        const changingCurve = changingFile.extractedData[indexExtractedData]
        const modifLinkedFile = changingFile.linkedFile && !this.CopySource.value
        changingCurve[fieldNameObjt] = newValue
        if(modifLinkedFile){
          this.prepareLinkedReportChanges(changingCurve.fileName, indexExtractedData);
          this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.LinkedReportChanges][changingCurve.fileName][indexExtractedData][fieldNameObjt] = newValue
        }
      }
      await this.loadTable()
      this.isLoading = false
      this.setConfigReportModifiedReportViewer()
    },
    changeEnableRow(indexCol,enableVal){
      this.setConfigReportModifiedReportViewer()
      const splitData = indexCol.split('.') //Get the Id
      const fileIndex = parseInt(splitData[0])
      const changingFile = this.dataFiles[fileIndex]
      const indexExtractedData = parseInt(splitData[1])
      const changingCurve = changingFile.extractedData[indexExtractedData]
      const modifLinkedFile = changingFile.linkedFile && !this.CopySource.value

      changingCurve.enabled = enableVal
      if(modifLinkedFile){
        this.prepareLinkedReportChanges(changingCurve.fileName, indexExtractedData);
        this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.LinkedReportChanges][changingCurve.fileName][indexExtractedData].enabled = enableVal
      }
      const indexDataTable = this.indexArray[fileIndex][indexExtractedData]
      const highLightArray = this.paramsTableProc.highlight.row
      const indexElem = highLightArray.indexOf(indexDataTable)
      if(enableVal){
        if(indexElem!==-1){
          highLightArray.splice(indexElem,1)
        }
        this.$set(this.paramsTableProc,'highlight',{row:highLightArray})
        return ENABLED_LABEL.slice()
      }else{
        if(indexElem===-1){
          highLightArray.push(indexDataTable)
        }
        this.$set(this.paramsTableProc,'highlight',{row:highLightArray})
        return DISABLED_LABEL.slice()
      }
    },
    onCellClick(rowIndex, ColumnIndex, data){
      if(ColumnIndex===3){
        const newData = this.paramsTableProc.data.slice()
        const rowData = newData[rowIndex]
        const splitData = rowData[0].split('.') //Get the Id
        const changingFile = this.dataFiles[parseInt(splitData[0])]
        if(changingFile.linkedFile && this.CopySource.value){
          const warnTitle='Modifying linked dataline'
          const warnText='Changes on linked dataline are not saved. Please disable the "Copy Source" switch'
          this.$notifTerm.addNotification(this.$notifTerm.typesNotif.WARNING, warnTitle, warnText, zoneNotify)
          this.$nextTick(() => this.loadTable(pagination, searchVal))
          return
        }
        rowData[3] = this.changeEnableRow(rowData[0],data!==ENABLED_LABEL) //So we toggle every click
        const pagination = Math.floor(rowIndex/10)+1
        const searchVal = this.$refs.tableProcFiles.searchValue
        this.loadTable(pagination,searchVal)
        this.setConfigReportModifiedReportViewer()
      }
    }
  }
}
</script>

<style scoped>
.sort-div{
  position: absolute;
  right: 0.3rem;
}
.table-processed{
  font-size: 0.65rem;
}
.floating-btn{
  float:right;
  padding: 4px;
  margin-top: 3px;
}
.extra-switch{
  font-size: 0.8rem;
}
.config-processed{
  border-top: solid 1px #707070;
}
::v-deep #processed-data .table-cell{
  width: 10px;
}
.loading-spinner{
  position: fixed;
  justify-content: end;
  width: 100%;
  padding-right: 4rem;
  padding-top: 0.25rem;
}
</style>